import React from "react";
 
import { withStyles } from "@material-ui/styles";
import StateInput from '../components/FilterSection/StateInput'
import SchemeInput from '../components/FilterSection/SchemeInput'
import YearInput from '../components/FilterSection/YearInput'

import styles from "../styles/OverviewStyles";

function Overview(props) {
  const { classes, isDarkMode, handleChange } = props;
  return (
    <div className={classes.root}>
      
        <div className={classes.panels}>
          <div className={classes.panelContainer}>
          <StateInput
            handleChange={handleChange}
          />
          </div>
          <div className={classes.panelContainer}>
            <SchemeInput
              handleChange={handleChange}
            />
          </div>
          <div className={classes.panelContainer}>
          <YearInput
            handleChange={handleChange}
          />
          </div>
        </div>
    </div>
  );
}

export default withStyles(styles)(Overview);
